import React, { useState, useEffect } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';

export default function LoyaltyPoints({ orderId, tableId, onSelect }) {
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [loyaltyAmount, setLoyaltyAmount] = useState(0);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const fetchLoyaltyPoints = async () => {
      if (!orderId && !tableId) return;

      let url = `${apiUrls.OFFERS_LOYALTY_POINTS}?type=loyalty_points`;
      if (tableId) url += `&table_id=${tableId}`;
      else if (orderId) url += `&order_id=${orderId}`;

      try {
        // withLoader=false - loyalty points are secondary; don't hold the
        // global loader open waiting on this while the rest of checkout
        // (cart items, summary, tender view) is already usable.
        const response = await callAPI(url, {}, 'GET', null, {}, {}, false);
        if (response.status === 200 && response.data?.data?.loyalty_points) {
          const lp = response.data.data.loyalty_points;
          setLoyaltyPoints(lp.loyalty_points || 0);
          setLoyaltyAmount(lp.loyalty_points_amount || 0);
        }
      } catch (error) {
        console.error('Error fetching loyalty points:', error);
      }
    };

    fetchLoyaltyPoints();
  }, [orderId, tableId]);

  const handleChange = () => {
    setIsChecked(!isChecked);
    if (onSelect) {
      onSelect(!isChecked ? loyaltyAmount : 0); // notify parent
    }
  };

  if (loyaltyPoints === 0) return null; // hide if no points available

  return (
    <div className="cardLgCol">
      <h4 className="lgTitle">Pay with Loyalty Points</h4>
      <div className="form-group checkStyle">
        <input
          type="checkbox"
          id="loyalty"
          checked={isChecked}
          onChange={handleChange}
        />
        <label htmlFor="loyalty" style={{paddingLeft:"10px"}}>
          Redeem loyalty points (<span>{loyaltyAmount}</span>)
        </label>
      </div>
    </div>
  );
}
